import ErrorText from '../ErrorText';
import Form from '../../Form/AuthForm';
import Input from '../../Form/AuthInput';
import { useTranslation } from 'react-i18next';

type Props = {
  password: string;
  passwordConfirm: string;
  isPasswordValid: boolean;
  isPasswordConfirmValid: boolean;
  setPassword(e: string): void;
  setPasswordConfirm(e: string): void;
  error: string;
};

const PasswordForm = ({
  passwordConfirm,
  setPassword,
  setPasswordConfirm,
  password,
  isPasswordValid,
  isPasswordConfirmValid,
  error,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Form>
      <ErrorText>{error}</ErrorText>
      <Input
        label={t('password')}
        type="password"
        value={password}
        error={!isPasswordValid}
        handleChange={setPassword}
      />
      <Input
        label={t('auth.password.confirm')}
        type="password"
        value={passwordConfirm}
        error={!isPasswordConfirmValid}
        handleChange={setPasswordConfirm}
      />
    </Form>
  );
};

export default PasswordForm;
